import * as React from 'react'

type InformationFieldProps = {
  caption: string
  value: any
}

export default function InformationField(props: InformationFieldProps) {
  const { caption, value } = props
  if (value === undefined || value === '') {
    return null
  }
  return (
    <div className="col-sm-6 col-lg-4">
      <span className="title mr-2 font-weight-bold">{`${caption}: `}</span>
      {value}
    </div>
  )
}